module.exports = __webpack_public_path__ + "media/images/how-we-test-9ebe139e91a0151f51c907b74e4abf9c.jpeg";